import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import AccordionDemo from './AccordionDemo'
import AccordionElement from './AccordionElement'
import AccordionFormBrand from './AccordionFormBrand'
import { ACCORDION_STYLE_FIELDS } from './AccordionFormStyle'
import AccordionFormValue from './AccordionFormValue'
import accordionIcon from './assets/accordion.svg'

export default genElementConfig(CONFIG_ELEMENTS.accordion, {
  label: t('elements.accordion.label'),
  group: ElementGroup.interactive,
  icon: accordionIcon,
  styleFields: ACCORDION_STYLE_FIELDS,
  Element: AccordionElement,
  Demo: [AccordionDemo],
  FormValue: AccordionFormValue,
  FormBrand: AccordionFormBrand,
  EditorActions: EditableProMode,
})
